import { useEffect, useState } from "react";
import { LuDot } from "react-icons/lu";

const FileUpload = ({
    id,
    accept,
    onChange,
    required,
    multiple,
}) => {
    return (
        <div className="relative rounded-xl border border-white/10 bg-white/5 p-1 focus-within:border-teal-400 focus-within:ring-2 focus-within:ring-teal-400/30">
            <input
                type="file"
                id={id}
                name={id}
                accept={accept}
                onChange={onChange}
                className="block w-full text-sm text-main-subfont
                    file:me-4 file:py-2 file:px-4
                    file:rounded-lg file:border-0
                    file:text-sm file:font-semibold
                    file:bg-gradient-to-r file:from-teal-500 file:to-cyan-500 file:text-white
                    file:shadow-lg file:shadow-teal-500/30
                    hover:file:brightness-110
                    file:disabled:opacity-50 file:disabled:pointer-events-none
                    focus:outline-none cursor-pointer"

                required={required}
                multiple={multiple}
            />
        </div>
    );
};

export default FileUpload;
